// import { guestUserLogin } from 'src/services/apiRequests/Login/LoginService';

import { guestUserLogin } from '../../services/apiRequests/Login/LoginService';
import SimpleStore from '../../store/SimpleStore';
import {
  deleteLocalStorage,
  getLocalStorage,
  setLocalStorage
} from '../browserStorageHandler';
import { getTempUserBearerToken } from '../common';
import { HTTP_HEADER_KEYS } from '../constants/HttpMethodsConstants';
import {
  CONSUMPTION_JOURNEY_CODE_REDEMPTION_OBJ,
  CONSUMPTION_PAYMENT_JOURNEY_PATH,
  CONSUMPTION_PAYMENT_SUCCESS,
  GUEST_USER_PAYMENT_DETAILS,
  GUEST_USER_REG_OBJ,
  IS_CONSUMPTION_PAYMENT_JOURNEY,
  RSJ_SUBSCRIPTION_PAYMENT_NOT_LINKED,
  SUBSCRIPTION_PAYMENT_NOT_LINKED,
  USER_TOKEN
} from '../constants/localStorageConstants';

export const getTempUserTransactionId = () => {
  const tempUserDetails = getLocalStorage(GUEST_USER_REG_OBJ);
  let transactionId = '';
  let code = '';
  if (tempUserDetails) {
    try {
      ({ transaction_id: transactionId = '', code = '' } =
        JSON.parse(tempUserDetails) || {});
    } catch (e) {
      console.error(
        'Error during json parsing of GUEST_USER_REG (user Details): ',
        e
      );
    }
  }
  if (transactionId && code && Number(code) === 209) {
    return transactionId;
  }
  return transactionId;
};

export const isConsumptionPaymentJourney = () =>
  !!getLocalStorage(IS_CONSUMPTION_PAYMENT_JOURNEY);

export const getConsumptionJourneyPath = () =>
  getLocalStorage(CONSUMPTION_PAYMENT_JOURNEY_PATH);

/* extract transaction ID from localstorage saved via "/getuserorder.php" (payment success data)
  API - only for guest user in new payment journey from consumption page */
export const getGuestUserPaymentTransactionId = () => {
  const guestUserPaymentDetails = getLocalStorage(GUEST_USER_PAYMENT_DETAILS);

  // extract "payment_id" from saved payment details
  let paymentId = '';
  if (guestUserPaymentDetails) {
    try {
      ({ payment_id: paymentId = '' } =
        JSON.parse(guestUserPaymentDetails) || {});
    } catch (e) {
      console.error(
        'Error during json parsing of guestUserPaymentDetails: ',
        e
      );
    }
  }

  return paymentId;
};

export const isGuestUserPaymentSuccess = () => {
  const paymentSuccessLocal = getLocalStorage(CONSUMPTION_PAYMENT_SUCCESS);
  if (paymentSuccessLocal) {
    try {
      const isPaymentSuccessful = JSON.parse(paymentSuccessLocal);
      return isPaymentSuccessful;
    } catch (e) {
      console.error(
        'Error during json parsing of ConsumptionPaymentSuccess: ',
        e
      );
    }
  }
  return false;
};

export const isGuestUserPaymentSuccessJourney = () => {
  const isGuestUserConsumptionPaymentJourney =
    isConsumptionPaymentJourney() && getTempUserBearerToken();
  const isGuestUserPaymentDone =
    isGuestUserPaymentSuccess() &&
    getGuestUserPaymentTransactionId().length > 0;
  return isGuestUserConsumptionPaymentJourney && isGuestUserPaymentDone;
};

export const getPaymentLinkStatus = () => {
  const paymentNotLinkedLocal = getLocalStorage(
    SUBSCRIPTION_PAYMENT_NOT_LINKED
  );
  if (paymentNotLinkedLocal) {
    try {
      const isPaymentNotLinked = JSON.parse(paymentNotLinkedLocal);
      return isPaymentNotLinked;
    } catch (e) {
      console.error(
        'Error while parsing subscriptionPaymentNotLinked json: ',
        e
      );
    }
  }
  return false;
};

type guestUserOtpParams = {
  mobile: string;
  otp: string;
  setActiveSubscriptionFound: (value: boolean) => void;
  resetToInitialScreen: () => void;
  setErrorAndLoader: (error: string, loader: boolean) => void;
};

// this method is used to handle the post otp verification flow for guest user and log the user in.
export const guestUserLoginOtpHandler = ({
  mobile,
  otp,
  setActiveSubscriptionFound,
  resetToInitialScreen,
  setErrorAndLoader
}: guestUserOtpParams) => {
  const isPrepaidJourney = getLocalStorage(
    CONSUMPTION_JOURNEY_CODE_REDEMPTION_OBJ
  );
  guestUserLogin({ mobile, otp })
    .then((data) => {
      setErrorAndLoader('', false);
      if (data?.access_token && data?.refresh_token && data?.expires_in) {
        /* if we get accesstoken(log the user in),
        delete guest user tokens & guest payment details from localstorage & reset flag for consumption payment journey */
        setLocalStorage(USER_TOKEN, data?.access_token);
        SimpleStore.set(HTTP_HEADER_KEYS.AUTHORIZATION, data?.access_token);
        deleteLocalStorage(GUEST_USER_REG_OBJ);
        deleteLocalStorage(GUEST_USER_PAYMENT_DETAILS);
        deleteLocalStorage(SUBSCRIPTION_PAYMENT_NOT_LINKED);
        deleteLocalStorage(RSJ_SUBSCRIPTION_PAYMENT_NOT_LINKED);
        deleteLocalStorage(CONSUMPTION_JOURNEY_CODE_REDEMPTION_OBJ);
        setActiveSubscriptionFound(false);
        if (data?.code === 200) {
          window.location.href = `/paymentsuccess${
            isPrepaidJourney ? '?prepaidsuccess=true' : ''
          }`;
        }
      } else if (data?.code === 3109) {
        resetToInitialScreen();
        setActiveSubscriptionFound(true);
      } else {
        // error handle here
        setErrorAndLoader(data?.message, false);
      }
    })
    .catch((error) => {
      console.error('Something went wrong when guest user login: ', error);
      // error handle here
      setErrorAndLoader(error?.message, false);
    });
};

export const getBuyPlanProperties = (currentCountry: string) => {
  const paymentSuccess = isGuestUserPaymentSuccess();
  const isIndia = currentCountry === 'IN';
  const orderId = getGuestUserPaymentTransactionId();
  const tempUserTransactionId = getTempUserTransactionId();
  const paymentNotLinked =
    getPaymentLinkStatus() &&
    (orderId || tempUserTransactionId) &&
    paymentSuccess;

  return {
    paymentSuccess,
    isIndia,
    orderId,
    tempUserTransactionId,
    paymentNotLinked
  };
};
